import { Injectable } from '@angular/core';
import { NotificationCustomerServicesService, NotificationMessageServicesService, NotificationCustomerP, CheckMessageInput, NotificationCustomerInput } from '../notification-api';
import { Observable } from 'rxjs';
import { AuthKey } from '../auth-key.enum';
import * as is from 'is_js';

@Injectable()
export class NotDataRestService {

  constructor(
    private restNotCust: NotificationCustomerServicesService,
    private restNotMessage: NotificationMessageServicesService,
  ) { }

  checkMessage(): Observable<NotificationCustomerP[]> {
    let checkMessageInput: CheckMessageInput = {
      customerGroupId: [1],
      customerId: JSON.parse((localStorage.getItem(AuthKey.LOGIN_KEY) || null)).customerId,
      product: [JSON.parse((localStorage.getItem(AuthKey.SUBSCRIPTION_KEY) || null)).productP.id]
    };
    return this.restNotMessage.checkMessageUsingPOST(checkMessageInput).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        return [];
      }
    })
  }

  viewedMessage(notificationId): Observable<boolean> {
    let notificationCustomerInput: NotificationCustomerInput = {
      notificationCustomerP : {
        customer: JSON.parse((localStorage.getItem(AuthKey.LOGIN_KEY) || null)).customerId,
        // id: 5,
        notificationMessage: notificationId,
        viewDate: new Date().getTime()
      }
    } 
    return this.restNotCust.createNotificationCustomerUsingPOST(notificationCustomerInput).map(response => {
      if (is.existy(response) && response.code == 200) {
        return true;
      }
      else {
        return false;
      }
    })
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/notification/not-data-rest.service.ts